import { render, staticRenderFns } from "./ResolveRequestForm.vue?vue&type=template&id=a6581312&scoped=true&"
import script from "./ResolveRequestForm.vue?vue&type=script&lang=js&"
export * from "./ResolveRequestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6581312",
  null
  
)

export default component.exports